import React from 'react';
import { useSelector } from 'react-redux';

const SubmitButtons = ({ submitText, resetText, cancelText, submitType, resetType, resetHandler, cancelHandler, submitHandler }) => {
    const { loading } = useSelector(state => state.course);

    return (
        <div className='gap-x-1 flex justify-between items-end'>
            <div className='flex justify-center items-end'>
                <button
                    className='rounded-md h-fit bg-richblack-200 cursor-pointer py-[8px] px-[20px] font-semibold transition-all duration-200 hover:scale-95 text-richblack-900'
                    onClick={cancelHandler}
                    disabled={loading}
                    type='button'
                >
                    {cancelText}
                </button>
            </div>
            <div className='flex justify-cneter items-end sm-4:gap-x-7 gap-x-2'>
                <button
                    className='rounded-md h-fit bg-richblack-200 cursor-pointer py-[8px] px-[20px] font-semibold transition-all duration-200 hover:scale-95 text-richblack-900'
                    onClick={resetHandler}
                    disabled={loading}
                    type={resetType}
                >
                    {resetText}
                </button>
                <button
                    className='bg-yellow-50 py-[8px] px-[20px] cursor-pointer font-semibold rounded-md transition-all duration-200 hover:scale-95 mt-6 text-richblack-900'
                    type={submitType}
                    disabled={loading}
                    onClick={submitHandler}
                >
                    {submitText}
                </button>
            </div>
        </div>
    );
}

export default SubmitButtons;